<template>
    <div style="background-color: #181a1b; color: white; padding: 20px; margin-top: 10px; border-radius: 10px;">
        <div style="float: left;">
            <button class="btn btn-link text-white" @click="handleBackButtonPress">
                <i class="fas fa-arrow-left"></i>
            </button>
        </div>
        <div>
            <h3><i class="fa-solid fa-user"></i> {{ candidateId["firstname"] }} {{ candidateId["lastname"] }}</h3>
        </div>
        <div class="d-flex">
            <div class="col p-3 w-10">
                <canvas class="chartCanvas" ref="chartCanvas"></canvas>
            </div>
            <div v-if="candidateAssessmentInformation" class="col p-3">
                <table class="dark-table">
                    <tbody>
                        <th>Assessment Code</th>
                        <th>Encountered</th>
                        <tr v-for="(value, key) in candidateAssessmentInformation.assessmentCodeCount" :key="key" class="clickable-row">
                            <td>{{ key }}</td>
                            <td>{{ value }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="candidateAssessmentInformation" style="overflow: auto;">
            <table class="dark-table">
                <tbody>
                    <th>Assessment Code(s)</th>
                    <th>Date Taken</th>
                    <tr v-for="(assessment, index) in candidateAssessmentInformation.assessmentsRecords" class="clickable-row" :key="index" @click="handleAssessmentClick(index)">
                        <td>{{ assessment.assessmentDetails.assessmentName }}</td>
                        <td>{{ assessment.assessmentDateFormatted }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import { endpoint } from '@/utils/endpoint/endpointUtils';
import { getCookie, deleteAllCookies } from '@/utils/cookies/cookieUtils';
import { getRandomHexColor } from '@/services/ColorsService';
import { Chart, registerables } from 'chart.js';

export default {
    props: ['candidateId'],
    data() {
        return {
            dataCounts : [],
            candidateAssessmentInformation: null,
            chartInstance: null,
        }
    },
    async mounted() {
        await this.fetchCandidateAssessments();
    },
    methods: {
        handleBackButtonPress() {
            // emit here
            this.$emit('back-button-pressed');
        },
        drawAssessmentPieChart() {
            this.dataCounts = [];
            var rndColors = [];

            if (this.chartInstance !== null) {
                this.chartInstance.destroy();
            }

            const ctx = this.$refs.chartCanvas.getContext('2d');

            for (const assessment in this.candidateAssessmentInformation.assessmentCodeCount) {
                if (Object.hasOwnProperty.call(this.candidateAssessmentInformation.assessmentCodeCount, assessment)) {
                    this.dataCounts.push(this.candidateAssessmentInformation.assessmentCodeCount[assessment]);
                    rndColors.push(getRandomHexColor());
                }
            }

            const data = {
                labels : this.candidateAssessmentInformation.assessmentCodes,
                datasets: [{
                    label: 'Assessment Types Taken',
                    data: this.dataCounts,
                    borderWidth: 1,
                    backgroundColor: rndColors
                }]
            };

            const config = {
                type: 'doughnut',
                data: data,
                options: {
                        plugins: {
                            legend: {

                            }
                        }
                    }
            };
            // Create a new chart instance
            this.chartInstance = new Chart(ctx, config);
        },
        async fetchCandidateAssessments() {
            try {
                const userid = getCookie('userid');
                const token = getCookie('token');

                const response = await fetch(endpoint + '/api/Assessments/GetAssessmentDetailsForUserId/' + userid + '?candidateId=' + this.$props.candidateId["candidateId"], {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json',
                }});

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                } else {
                    const data = await response.json();
                    console.log(data);
                    this.candidateAssessmentInformation = data.assessments;
                    if (!this.chartInstance) {                    
                        this.drawAssessmentPieChart();
                    }
                }
            } catch(exception) { 
                console.log(exception); 
                deleteAllCookies();
            }
        },
        handleAssessmentClick(index) {
            this.$emit('assessment-returned', this.candidateAssessmentInformation.assessmentsRecords[index]);
        }
    }
}
</script>
<style scoped>
.clickable-row {
  cursor: pointer;
}

.dark-table {
    background-color: #292929; /* Dark gray background */
    color: #fff; /* White text color */
    border-collapse: collapse; /* Remove default cell spacing */
    width: 100%;
}

.dark-table th,
.dark-table td {
    padding: 10px; /* Add padding to cells */
    border: 1px solid #383838; /* Dark border for cells */
}

.dark-table th {
    background-color: #3f3f3f; /* Darker gray for table header */
}

.dark-table tbody tr:nth-child(even) {
    background-color: #333; /* Darker background for even rows */
}

.dark-table tbody tr:hover {
    background-color: #4f4f4f; /* Darker background for hover effect */
}

/* Hint of purple */
.dark-table th,
.dark-table td {
    border: 1px solid #383838; /* Dark border for cells */
}

.dark-table th {
    background-color: #27202c; /* Purple background for table header */
    position: sticky;
    z-index: 2;
    top: 0;
}

.dark-table tbody tr:nth-child(even) {
    background-color: #363438; /* Purple background for even rows */
}

.dark-table tbody tr:hover {
    background-color: #2b1542; /* Darker purple background for hover effect */
}
</style>